import {
  ITEMAUTOTOPUPBILLING,
  RESPONSEAUTOVALIDCUSTOMER,
  RESPONSECREATEAUTO,
  ITEMTRANSACTIONAUTO,
} from "app/shared/services/services-model.type";
import { FormAutoTopUpFilterHistory } from "../auto-history/filter-history-table/filter-history";
import {
  SET_AUTO_TOP_UP_STORE,
  SET_AUTO_TOP_UP_RESET,
  FETCH_AUTO_TOP_UP_LIST_REQUEST,
  FETCH_AUTO_TOP_UP_LIST_SUCCESS,
  FETCH_AUTO_TOP_UP_LIST_FAILURE,
  FETCH_AUTO_TOP_UP_DELETE_REQUEST,
  FETCH_AUTO_TOP_UP_DELETE_SUCCESS,
  FETCH_AUTO_TOP_UP_DELETE_FAILURE,
  FETCH_AUTO_TOP_UP_LIST_PROVIDER_REQUEST,
  FETCH_AUTO_TOP_UP_LIST_PROVIDER_SUCCESS,
  FETCH_AUTO_TOP_UP_LIST_PROVIDER_FAILURE,
  FETCH_AUTO_TOP_UP_VALID_PHONE_REQUEST,
  FETCH_AUTO_TOP_UP_VALID_PHONE_SUCCESS,
  FETCH_AUTO_TOP_UP_VALID_PHONE_FAILURE,
  FETCH_AUTO_TOP_UP_CREATE_REQUEST,
  FETCH_AUTO_TOP_UP_CREATE_SUCCESS,
  FETCH_AUTO_TOP_UP_CREATE_FAILURE,
  FETCH_AUTO_TOP_UP_AUTHORIZATION_KEY_REQUEST,
  FETCH_AUTO_TOP_UP_AUTHORIZATION_KEY_SUCCESS,
  FETCH_AUTO_TOP_UP_AUTHORIZATION_KEY_FAILURE,
  FETCH_AUTO_TOP_UP_TRANSACTION_REQUEST,
  FETCH_AUTO_TOP_UP_TRANSACTION_SUCCESS,
  FETCH_AUTO_TOP_UP_TRANSACTION_FAILURE,
} from "./actions.type";
import {
  DataAutoTopUpCreate,
  SetAutoTopUpStore,
  AutoTopUpState,
  SetAutoTopUpReset,
  FetchAutoTopUpListRequest,
  FetchAutoTopUpListSuccess,
  FetchAutoTopUpListFailure,
  FetchAutoTopUpDeleteRequest,
  FetchAutoTopUpDeleteSuccess,
  FetchAutoTopUpDeleteFailure,
  FetchAutoTopUpListProviderRequest,
  FetchAutoTopUpListProviderSuccess,
  FetchAutoTopUpListProviderFailure,
  FetchAutoTopUpValidPhoneRequest,
  FetchAutoTopUpValidPhoneSuccess,
  FetchAutoTopUpValidPhoneFailure,
  FetchAutoTopUpCreateRequest,
  FetchAutoTopUpCreateSuccess,
  FetchAutoTopUpCreateFailure,
  FetchAutoTopUpAuthorizationRequest,
  FetchAutoTopUpAuthorizationSuccess,
  FetchAutoTopUpAuthorizationFailure,
  FetchAutoTopUpTransactionRequest,
  FetchAutoTopUpTransactionSuccess,
  FetchAutoTopUpTransactionFailure,
} from "./types";

export const fetchAutoTopUpListRequest = (payload?: string): FetchAutoTopUpListRequest => ({
  type: FETCH_AUTO_TOP_UP_LIST_REQUEST,
  payload,
});

export const fetchAutoTopUpListSuccess = (payload?: ITEMAUTOTOPUPBILLING[]): FetchAutoTopUpListSuccess => ({
  type: FETCH_AUTO_TOP_UP_LIST_SUCCESS,
  payload,
});

export const fetchAutoTopUpListFailure = (payload?: string): FetchAutoTopUpListFailure => ({
  type: FETCH_AUTO_TOP_UP_LIST_FAILURE,
  payload,
});

export const fetchAutoTopUpDeleteRequest = (payload?: ITEMAUTOTOPUPBILLING): FetchAutoTopUpDeleteRequest => ({
  type: FETCH_AUTO_TOP_UP_DELETE_REQUEST,
  payload,
});

export const fetchAutoTopUpDeleteSuccess = (payload?: RESPONSEAUTOVALIDCUSTOMER): FetchAutoTopUpDeleteSuccess => ({
  type: FETCH_AUTO_TOP_UP_DELETE_SUCCESS,
  payload,
});

export const fetchAutoTopUpDeleteFailure = (payload?: string): FetchAutoTopUpDeleteFailure => ({
  type: FETCH_AUTO_TOP_UP_DELETE_FAILURE,
  payload,
});

export const fetchAutoTopUpListProviderRequest = (payload?: string): FetchAutoTopUpListProviderRequest => ({
  type: FETCH_AUTO_TOP_UP_LIST_PROVIDER_REQUEST,
  payload,
});

export const fetchAutoTopUpListProviderSuccess = (payload?: Array<string>): FetchAutoTopUpListProviderSuccess => ({
  type: FETCH_AUTO_TOP_UP_LIST_PROVIDER_SUCCESS,
  payload,
});

export const fetchAutoTopUpListProviderFailure = (payload?: string): FetchAutoTopUpListProviderFailure => ({
  type: FETCH_AUTO_TOP_UP_LIST_PROVIDER_FAILURE,
  payload,
});

export const fetchAutoTopUpValidPhoneRequest = (payload?: DataAutoTopUpCreate): FetchAutoTopUpValidPhoneRequest => ({
  type: FETCH_AUTO_TOP_UP_VALID_PHONE_REQUEST,
  payload,
});

export const fetchAutoTopUpValidPhoneSuccess = (payload?: RESPONSEAUTOVALIDCUSTOMER): FetchAutoTopUpValidPhoneSuccess => ({
  type: FETCH_AUTO_TOP_UP_VALID_PHONE_SUCCESS,
  payload,
});

export const fetchAutoTopUpValidPhoneFailure = (payload?: string): FetchAutoTopUpValidPhoneFailure => ({
  type: FETCH_AUTO_TOP_UP_VALID_PHONE_FAILURE,
  payload,
});

export const fetchAutoTopUpCreateRequest = (payload?: DataAutoTopUpCreate): FetchAutoTopUpCreateRequest => ({
  type: FETCH_AUTO_TOP_UP_CREATE_REQUEST,
  payload,
});

export const fetchAutoTopUpCreateSuccess = (payload?: RESPONSECREATEAUTO): FetchAutoTopUpCreateSuccess => ({
  type: FETCH_AUTO_TOP_UP_CREATE_SUCCESS,
  payload,
});

export const fetchAutoTopUpCreateFailure = (payload?: string): FetchAutoTopUpCreateFailure => ({
  type: FETCH_AUTO_TOP_UP_CREATE_FAILURE,
  payload,
});

export const fetchAutoTopUpAuthorizationRequest = (payload?: RESPONSECREATEAUTO, code?: string): FetchAutoTopUpAuthorizationRequest => ({
  type: FETCH_AUTO_TOP_UP_AUTHORIZATION_KEY_REQUEST,
  payload,
  code,
});

export const fetchAutoTopUpAuthorizationSuccess = (payload?: any): FetchAutoTopUpAuthorizationSuccess => ({
  type: FETCH_AUTO_TOP_UP_AUTHORIZATION_KEY_SUCCESS,
  payload,
});

export const fetchAutoTopUpAuthorizationFailure = (errorOTP: boolean, payload?: string): FetchAutoTopUpAuthorizationFailure => ({
  type: FETCH_AUTO_TOP_UP_AUTHORIZATION_KEY_FAILURE,
  errorOTP,
  payload,
});

export const fetchAutoTopUpTransactionRequest = (payload?: FormAutoTopUpFilterHistory): FetchAutoTopUpTransactionRequest => ({
  type: FETCH_AUTO_TOP_UP_TRANSACTION_REQUEST,
  payload,
});

export const fetchAutoTopUpTransactionSuccess = (payload?: ITEMTRANSACTIONAUTO[]): FetchAutoTopUpTransactionSuccess => ({
  type: FETCH_AUTO_TOP_UP_TRANSACTION_SUCCESS,
  payload,
});

export const fetchAutoTopUpTransactionFailure = (payload?: string): FetchAutoTopUpTransactionFailure => ({
  type: FETCH_AUTO_TOP_UP_TRANSACTION_FAILURE,
  payload,
});

export const setAutoTopUpStore = (payload: AutoTopUpState): SetAutoTopUpStore => ({
  type: SET_AUTO_TOP_UP_STORE,
  payload,
});

export const setAutoTopUpReset = (): SetAutoTopUpReset => ({
  type: SET_AUTO_TOP_UP_RESET,
});
